///<reference path="../../../typings/tsd.d.ts" />
///<reference path="../../bindings/commons/API/Client/api.d.ts" />
///<reference path="../../bindings/address/API/Client/AddressModel.ts" />
///<reference path="address-service.ts" />

module address.controller {

    import api = API.Client;
    
    export class AddressConfig {
        cities: Array<API.Client.City> = [];
        cepSearchError: Boolean = false;
        loader: common.Loader = new common.Loader();        
        constructor() {};
    }

    export class AddressController {
        config: AddressConfig;
        service: address.AddressService;
        $q: ng.IQService;
        address: API.Client.AddressModel;

        /*@ngInject*/
        constructor(
            $scope?: ng.IScope, 
            $state?: angular.ui.IState, 
            $q?: ng.IQService,
            addressService?: address.AddressService
        ) {
            this.service = addressService;
            this.$q = $q;
        };

        getCities(countryCode: string, stateCode: string): ng.IPromise<Array<API.Client.City>> {
            return this.service.getCity(this.address.countryCode, this.address.stateCode).then(cities => {
                return cities;
            });
        };
        
        getCep(zipCode: number): ng.IPromise<API.Client.AddressModel> {
            let defer = this.$q.defer();
            
            this.service.getCep(zipCode).then(address => {
                if (address){
                    this.address = $.extend(this.address, address);
                    this.address.zipCode = zipCode;
                    defer.resolve(this.address);
                }
                else
                    defer.reject(zipCode);
            });
            
            return defer.promise;
        };
    }
}

angular.module('address').controller('addressController', address.controller.AddressController);
